export const setToken = (token) => {
    if (!token) {
        return false;
    }
    localStorage.setItem('token', token);
    return true;
};
export const clearToken = () => {
    localStorage.setItem('token', '');
};
